import React, { useState } from 'react';
import { ArrowRight, HeartIcon } from 'lucide-react';
import { DS } from '../ds';
import { GradientText } from '../Visuals';
import { Label, P } from '../Primitives';
export const KitSection = ({
  onCTA
}: {
  onCTA?: (id: string) => void;
}) => {
  const [activeDetail, setActiveDetail] = useState(0);
  const details = [{
    title: 'Caja kraft natural',
    desc: 'Cartón reciclado premium. Logo impreso con tinta de base agua. La textura comunica cuidado artesanal en cada caso.',
    tag: 'Eco · Reciclado · Personalizable',
    image: 'https://cdn.magicpatterns.com/uploads/6kE4wDGiWSF3PswBxPcucs/WhatsApp_Image_2026-07-16_at_9.57.51_AM_(1).jpg',
    imageAlt: 'Caja kraft natural Alinova abierta'
  }, {
    title: 'Bolsa de tela lino',
    desc: 'Lino natural bordado con logo. Reutilizable, duradera y sostenible. Una experiencia táctil que ningún otro brand ofrece.',
    tag: 'Natural · Bordado · Durable',
    image: 'https://cdn.magicpatterns.com/uploads/8VgHaqwJekps6FkM8nVUxD/WhatsApp_Image_2026-07-16_at_9.58.53_AM.jpg',
    imageAlt: 'Bolsa de tela lino Alinova con logo bordado'
  }, {
    title: 'Estuche con espejo',
    desc: 'Bioplástico con cierre premium y espejo interior. Diseñado para el uso cotidiano del paciente.',
    tag: 'Bioplástico · Funcional · Sostenible',
    image: 'https://cdn.magicpatterns.com/uploads/hFPsU1uMafTeDoUjiYwVnp/WhatsApp_Image_2026-07-28_at_9.10.56_PM.jpg',
    imageAlt: 'Estuche Alinova con espejo y alineadores transparentes'
  }, {
    title: 'Acceso digital + detalle de marca',
    tag: 'Digital · Premium · Memorable',
    desc: 'Tarjeta de acceso a la plataforma Alinova con QR para seguimiento del caso, más un pequeño obsequio físico que cierra la experiencia del tratamiento.',
    image: 'https://cdn.magicpatterns.com/uploads/huaduGvfbNsEbRpNdjnne5/WhatsApp_Image_2026-07-28_at_9.08.46_PM.jpg',
    imageAlt: 'Experiencia Alinova con acceso digital y detalle de marca'
  }];
  return <section id="kit" style={{
    padding: '80px 24px 0',
    background: `linear-gradient(160deg, ${DS.color.linen} 0%, ${DS.color.ivory} 60%)`,
    position: 'relative',
    overflow: 'hidden'
  }} data-id="element-599" data-mp="3qtlp8ii3ibjy">
      {/* Textura de fondo */}
      <div style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23B5894F' fill-opacity='0.025'%3E%3Cpath d='M0 0h80v80H0z'/%3E%3Ccircle cx='40' cy='40' r='2'/%3E%3C/g%3E%3C/svg%3E\")",
      pointerEvents: 'none'
    }} data-id="element-600" data-mp="3vrwxwpwnmg0l" />

      <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 1
    }} data-id="element-601" data-mp="iel7ahckkj9y">
        {/* Header */}
        <div style={{
        textAlign: 'center',
        maxWidth: '680px',
        margin: '0 auto 64px'
      }} data-id="element-602" data-mp="scivj4ufig2k">
          <div style={{
          display: 'flex',
          justifyContent: 'center'
        }} data-id="element-603" data-mp="1bvf3p78goiul">
            <Label data-id="element-604" data-mp="1fybg2g7eriq3">Kit eco-premium</Label>
          </div>
          <h2 style={{
          fontFamily: DS.font.heading,
          fontWeight: 700,
          fontSize: 'clamp(2rem, 4.5vw, 3.2rem)',
          color: DS.color.ink,
          lineHeight: 1.12,
          letterSpacing: '-0.025em',
          marginBottom: '20px'
        }} data-id="element-605" data-mp="11zlgmtx496yk">
            Una experiencia que también{' '}
            <GradientText data-id="element-606" data-mp="j8klyi313xkt">se siente en la entrega.</GradientText>
          </h2>
          <div style={{
          display: 'flex',
          justifyContent: 'center'
        }} data-id="element-607" data-mp="j6hlt585wo2d">
            <P align="center" maxWidth="560px" data-id="element-608" data-mp="o8gla40s70u1">
              El único sistema de alineadores en Colombia con una presentación
              eco-premium que eleva la percepción de tu clínica en cada caso.
            </P>
          </div>
        </div>

        {/* Grid imagen + detalles */}
        <div className="col-2" style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1.1fr',
        gap: '48px',
        alignItems: 'center'
      }} data-id="element-609" data-mp="1hjdfyp0410pa">
          {/* Imagen */}
          <div style={{
          position: 'relative'
        }} data-id="element-610" data-mp="17s8y9hj1v1qr">
            <div style={{
            borderRadius: DS.radius.cardLg,
            overflow: 'hidden',
            boxShadow: '0 32px 100px rgba(11,31,36,0.18)',
            background: DS.color.linen,
            aspectRatio: '4/5',
            position: 'relative'
          }} data-id="element-611" data-mp="12uh9gwdpbvqs">
              <img src={details[activeDetail].image} alt={details[activeDetail].imageAlt} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
              transition: `transform 0.5s ${DS.ease.smooth}`
            }} onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'} onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'} data-id="element-612" data-mp="oxtz9rwqn92x" />
            </div>

            {/* Badge flotante */}
            <div style={{
            position: 'absolute',
            bottom: '24px',
            left: '-16px',
            background: DS.color.tealDeep,
            borderRadius: '16px',
            padding: '14px 18px',
            boxShadow: '0 12px 40px rgba(13,59,80,0.28)',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }} data-id="element-613" data-mp="22vkmoa4md1kj">
              <HeartIcon size={24} color={DS.color.aquaLight} strokeWidth={1.6} data-id="element-614" data-mp="3o8dzbbaxge6w" />
              <div data-id="element-615" data-mp="3t6fgfqosm3fq">
                <div style={{
                fontFamily: DS.font.heading,
                fontWeight: 700,
                fontSize: '13px',
                color: '#fff'
              }} data-id="element-616" data-mp="3t5xf4fn9wz0y">
                  Experiencia real
                </div>
                <div style={{
                fontFamily: DS.font.body,
                fontSize: '11px',
                color: 'rgba(255,255,255,0.55)'
              }} data-id="element-617" data-mp="22431qnir5y0t">
                  Kit Alinova
                </div>
              </div>
            </div>
          </div>

          {/* Detalles accordion */}
          <div data-id="element-618" data-mp="1j8cvup7p8hhn">
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
          }} data-id="element-619" data-mp="1j8w39bzq3nhf">
              {details.map((d, i) => {
              const isActive = activeDetail === i;
              return <button key={i} onClick={() => setActiveDetail(i)} aria-expanded={isActive} style={{
                textAlign: 'left',
                cursor: 'pointer',
                borderRadius: '18px',
                padding: isActive ? '22px 24px' : '16px 24px',
                background: isActive ? '#fff' : 'rgba(255,255,255,0.55)',
                border: `1.5px solid ${isActive ? DS.color.kraft : DS.color.border}`,
                boxShadow: isActive ? '0 12px 40px rgba(11,31,36,0.09)' : 'none',
                transition: `all 0.28s ${DS.ease.smooth}`
              }} onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.85)';
                  e.currentTarget.style.borderColor = DS.color.linen;
                }
              }} onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.55)';
                  e.currentTarget.style.borderColor = DS.color.border;
                }
              }} data-id="element-620" data-mp="mox7qyafbtsq" data-mpi={i}>
                    <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px'
                }} data-id="element-621" data-mp="2edljxus4i8ha">
                      <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '12px',
                    flexShrink: 0,
                    background: isActive ? `linear-gradient(135deg, ${DS.color.kraft}, #9a6f3a)` : DS.color.linen,
                    color: isActive ? '#fff' : DS.color.kraft,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: DS.font.heading,
                    fontWeight: 700,
                    fontSize: '15px',
                    transition: 'all 0.28s'
                  }} data-id="element-622" data-mp="364jbgvir7n16">
                        {String(i + 1).padStart(2, '0')}
                      </div>
                      <div style={{
                    flex: 1
                  }} data-id="element-623" data-mp="1zhwuo5dbd60b">
                        <div style={{
                      fontFamily: DS.font.heading,
                      fontWeight: 700,
                      fontSize: '16px',
                      color: DS.color.ink
                    }} data-id="element-624" data-mp="1zglqi4fyhw8o">
                          {d.title}
                        </div>
                        {isActive && <div style={{
                      fontFamily: DS.font.body,
                      fontSize: '11px',
                      fontWeight: 600,
                      color: DS.color.kraft,
                      marginTop: '2px',
                      letterSpacing: '0.02em'
                    }} data-id="element-625" data-mp="2i6k0iq3bdzey">
                            {d.tag}
                          </div>}
                      </div>
                    </div>

                    {isActive && <div style={{
                  marginTop: '14px',
                  paddingLeft: '56px'
                }} data-id="element-626" data-mp="2lp0309p3a41t">
                        <P size="base" data-id="element-627" data-mp="rb8lko0iqfvt">{d.desc}</P>
                      </div>}
                  </button>;
            })}
            </div>
          </div>
        </div>

        {/* CTA — Verifica nuestros precios */}
        <div style={{
        marginTop: '48px',
        padding: '20px 28px',
        borderRadius: '16px',
        background: DS.color.white,
        border: `1px solid ${DS.color.border}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '16px',
        flexWrap: 'wrap'
      }} data-id="element-628" data-mp="num93a3jisat">
          <div data-id="element-629" data-mp="16r488ckpxuh3">
            <div style={{
            fontFamily: DS.font.heading,
            fontWeight: 700,
            fontSize: '15px',
            color: DS.color.ink,
            marginBottom: '3px'
          }} data-id="element-630" data-mp="16pje2o2bgdjr">
              ¿Quieres saber cuánto incluye el kit en cada plan?
            </div>
            <div style={{
            fontFamily: DS.font.body,
            fontSize: '13px',
            color: DS.color.muted
          }} data-id="element-631" data-mp="3ihq1neys8os4">
              Cada modalidad incluye el kit eco-premium completo desde el primer caso.
            </div>
          </div>

          <a href="#planes" onClick={e => {
          e.preventDefault();
          onCTA?.('planes');
        }} style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '11px 24px',
          borderRadius: DS.radius.pill,
          background: DS.color.kraft,
          color: '#fff',
          fontFamily: DS.font.body,
          fontSize: '14px',
          fontWeight: 700,
          textDecoration: 'none',
          transition: `all 0.22s ${DS.ease.smooth}`,
          whiteSpace: 'nowrap'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#9a6f3a';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = DS.color.kraft;
        }} data-id="element-632" data-mp="3jxkcit16jbj5">
            Verifica nuestros precios
            <ArrowRight size={15} aria-hidden="true" data-id="element-633" data-mp="1ypkh5q1azkat" />
          </a>
        </div>
      </div>

      {/* Espaciado inferior */}
      <div style={{
      height: '40px'
    }} data-id="element-634" data-mp="27nwfke8evmdt" />
    </section>;
};